import * as React from 'react';
import { useSelector } from 'react-redux';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { getNewbuildingIdsForBuildersPromoSlider } from '../../selectors/newbuildingPromoCarousel';
import { NewbuildingPromoCarouselLoadableContainer } from './NewbuildingPromoCarouselLoadable';
import { NewbuildingPromoCarouselLayout } from '../../components/NewbuildingPromoCarouselLayout';
import { NewbuildingPromoCarouselReservedSpace } from '../../components/NewbuildingPromoCarouselReservedSpace';
import { selectTotal } from '../../selectors/offersData';

export function LazyNewbuildingPromoCarouselContainer() {
  const [isVisible, setIsVisible] = React.useState(false);
  const [isLoadableError, setIsLoadableError] = React.useState(false);
  const newbuildingIds = useSelector(getNewbuildingIdsForBuildersPromoSlider);
  const total = useSelector(selectTotal);

  const handleShow = React.useCallback(() => {
    setIsVisible(true);
  }, []);

  const handleLoadableError = React.useCallback(() => {
    setIsLoadableError(true);
  }, []);

  if (!newbuildingIds.length || !total || isLoadableError) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handleShow} percentVisible={0.1}>
      <NewbuildingPromoCarouselReservedSpace>
        {isVisible && (
          <NewbuildingPromoCarouselLayout title="Популярные жилые комплексы от застройщиков">
            <NewbuildingPromoCarouselLoadableContainer
              newbuildingIds={newbuildingIds}
              onLoadableError={handleLoadableError}
            />
          </NewbuildingPromoCarouselLayout>
        )}
      </NewbuildingPromoCarouselReservedSpace>
    </ActionAfterViewObserver>
  );
}
